<template>
  <div class="sdg" style="width: 100%; min-height: 100vh; background: rgb(237, 241, 255); padding-bottom: 50px" v-if="pay_way">
    <div style="width: 100%; background: #fff">
      <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7" title="存款" left-arrow @click-left="$router.back()" />
      <div style="height: 46px"></div>

      <div class="typelis">
        <div :class="pay_way == 'bank' ? 'tyls atc' : 'tyls'" @click="changPayway('bank')" v-if="payWayList.card == 1">
          <img src="/static/image/icoOnlineTransfer2@3x.png" alt="" />网银转账
        </div>
        <div :class="pay_way == 'usdt' ? 'tyls atc' : 'tyls'" @click="changPayway('usdt')" v-if="payWayList.usdt == 1">
          <img src="/static/image/1595237922936176.png" alt="" />USDT
        </div>
        <div :class="pay_way == 'wechat' ? 'tyls atc' : 'tyls'" @click="changPayway('wechat')" v-if="payWayList.wechat == 1">
          <img src="/static/image/QuickWechat.png" alt="" />微信
        </div>
        <div :class="pay_way == 'alipay' ? 'tyls atc' : 'tyls'" @click="changPayway('alipay')" v-if="payWayList.alipay == 1">
          <img src="/static/image/icoAlipay2@3x.png" alt="" />支付宝
        </div>
        <div :class="pay_way == 'direct_wechat' ? 'tyls atc' : 'tyls'" @click="changPayway('direct_wechat')" v-if="payWayList.direct_wechat == 1">
          <img src="/static/image/QuickWechat.png" alt="" />直充微信
        </div>
        <div :class="pay_way == 'direct_alipay' ? 'tyls atc' : 'tyls'" @click="changPayway('direct_alipay')" v-if="payWayList.direct_alipay == 1">
          <img src="/static/image/icoAlipay2@3x.png" alt="" />直充支付宝
        </div>
      </div>

      <div v-if="pay_way == 'bank'">
        <div class="usrse">
          <div class="bans" v-for="(item, index) in cardLis" :key="index">
            <p>
              <span class="frists">收款账号</span><span class="sdsw">{{ item.bank_no }}</span>
              <span class="copy" @click="doCopy(item.bank_no)">复制</span>
            </p>
            <p>
              <span class="frists">银行户名</span><span class="sdsw">{{ item.bank_owner }}</span>
              <span class="copy" @click="doCopy(item.bank_owner)">复制</span>
            </p>
            <p>
              <span class="frists">开户行</span><span class="sdsw">{{ item.bank_data.bank_name }}</span>
              <span class="copy" @click="doCopy(item.bank_data.bank_name)">复制</span>
            </p>
            <p>
              <span class="frists">银行地址</span><span class="sdsw">{{ item.bank_address }}</span>
              <span class="copy" @click="doCopy(item.bank_address)">复制</span>
            </p>
          </div>

          <div class="hgs" @click="changShow">
            <div class="nams">开户银行</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field v-model="bankBox.bank" type="text" placeholder="选择开户银行" disabled />
              </van-cell-group>
            </div>
          </div>

          <div style="height: 0.2rem; background: #f8f8f8"></div>
          <div class="hgs">
            <div class="nams">存款人姓名</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field v-model="bankBox.bank_owner" type="text" placeholder="请输入存款人姓名" />
              </van-cell-group>
            </div>
            <div class="lasthg">为及时到账，请务必输入正确的存款人姓名</div>
          </div>

          <div style="height: 0.2rem; background: #f8f8f8"></div>
          <div class="hgs">
            <div class="nams">银行卡号</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field v-model="bankBox.bank_no" type="text" placeholder="请输入银行卡号" />
              </van-cell-group>
            </div>
          </div>

          <div style="height: 0.2rem; background: #f8f8f8"></div>
          <div class="hgs">
            <div class="nams">开户行地址</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field v-model="bankBox.bank_address" type="text" placeholder="请输入开户行地址" />
              </van-cell-group>
            </div>
          </div>

          <div style="height: 0.2rem; background: #f8f8f8"></div>
          <div class="hgs">
            <div class="nams">存款金额</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field label="￥" v-model="amount" type="text" :placeholder="`请输入存款金额 ${min_price} - ${max_price}`">
                  <template #button><span style="color: #000">元</span></template>
                </van-field>
              </van-cell-group>
            </div>
          </div>
        </div>
      </div>

      <div v-if="pay_way == 'usdt'">
        <div class="tipsh">
          <div class="tops">USDT价格稳定 流通性高 不受监管 <span @click="$parent.goNav('/usdtmore')">了解更多 ></span></div>
          <div class="tsg">
            <div class="tsgs">绑定协议地址</div>
            <div class="tsgs">交易所划转</div>
            <div class="tsgs">完成存款</div>
          </div>
        </div>
        <div class="usrse">
          <div class="hgs">
            <div class="nams sc">
              钱包协议
              <div :class="meyXi == 'TRC20' ? 'ssa acti' : 'ssa'" @click="changXiyi('TRC20')">TRC20</div>
              <div :class="meyXi == 'ERC20' ? 'ssa acti' : 'ssa'" style="margin-left: 0.5rem" @click="changXiyi('ERC20')">ERC20</div>
            </div>
          </div>

          <div style="height: 0.2rem; background: #f8f8f8"></div>
          <div class="hgs">
            <div class="nams">存款金额</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field label="￥" v-model="amount" type="text" :placeholder="`请输入存款金额 ${min_price} - ${max_price}`">
                  <template #button><span style="color: #000">元</span></template>
                </van-field>
              </van-cell-group>
            </div>
            <div class="lasthg">
              <span style="color: red; font-size: 0.43rem; margin-right: 10px">≈ </span>
              {{ amount ? Math.floor((amount / $store.state.userInfo.usdtrate) * 100) / 100 : '0.00' }} USDT
              参考汇率：{{ $store.state.userInfo.usdtrate }}
            </div>
          </div>

          <div style="height: 0.2rem; background: #f8f8f8"></div>
          <div class="hgs">
            <div class="nams">温馨提示</div>
            <div class="lasthg" style="border-top: 1px solid #eee; margin-top: 10px">
              请选择正确的USDT协议付款，若选择错误，平台将无法收到您的付款，不承担任何责任！
            </div>
          </div>
        </div>
      </div>

      <div v-if="pay_way == 'wechat' || pay_way == 'alipay'">
        <div style="height: 0.2rem; background: #f8f8f8"></div>
        <div class="usrse">
          <div class="hgs">
            <div class="nams">存款金额</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field label="￥" v-model="amount" type="text" :placeholder="`请输入存款金额 ${min_price} - ${max_price}`">
                  <template #button><span style="color: #000">元</span></template>
                </van-field>
              </van-cell-group>
            </div>
          </div>
        </div>
      </div>

      <div v-if="pay_way == 'direct_wechat' || pay_way == 'direct_alipay'">
        <div class="usrse">
          <div class="hgs">
            <div class="nams">请选择收款方式</div>
            <div class="direct-tag-list">
              <div
                v-for="item in directPayList"
                :key="item.id"
                :class="selectedDirectPay && selectedDirectPay.id === item.id ? 'direct-tag atc' : 'direct-tag'"
                @click="selectDirectPay(item)"
              >
                <span class="direct-tag-text">{{ item.content }}</span>
                <i v-if="selectedDirectPay && selectedDirectPay.id === item.id" class="direct-tag-check"></i>
              </div>
            </div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8"></div>
          <div class="hgs">
            <div class="nams">存款金额</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field label="￥" v-model="amount" type="text" :placeholder="directAmountPlaceholder">
                  <template #button><span style="color: #000">元</span></template>
                </van-field>
              </van-cell-group>
            </div>
          </div>
        </div>
      </div>

      <div style="margin: 0 auto; width: 86%">
        <van-button type="info" style="margin-top: 20px; width: 100%" @click="payTest">立即存款</van-button>
      </div>
    </div>

    <div v-if="show" style="position: fixed; width: 100%; height: 100%; top: 0; z-index: 999; background: rgba(0,0,0,0.4)">
      <van-picker style="position: absolute; bottom: 0; left: 0; width: 100%" title="银行类型" show-toolbar :columns="banklist"
        @confirm="onConfirm" @cancel="onCancel" value-key="bank_name" />
    </div>

    <van-popup v-model="popup" position="bottom">
      <van-picker show-toolbar :columns="columns" @confirm="onPayWayChange" @cancel="popup = false" />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'recharge',
  data() {
    return {
      pay_way: 'wechat',
      pay_way_name: '微信',
      pay_way_code: 'wechat',
      payInfo: {},
      amount: null,
      cardLis: [],
      banklist: [],
      bankBox: {},
      meyXi: 'TRC20',
      payWayList: {},
      directPayList: [],
      selectedDirectPay: null,
      show: false,
      userbank: [],
      userUSD: [1],
      min_price: 10,
      max_price: 100000,
      popup: false,
      columns: [
        { text: '网银转账', value: 'bank' },
        { text: 'USDT', value: 'usdt' },
        { text: '微信', value: 'wechat' },
        { text: '支付宝', value: 'alipay' },
      ],
    };
  },
  computed: {
    directAmountPlaceholder() {
      if (this.selectedDirectPay) {
        return `请输入存款金额 ${this.selectedDirectPay.min_price} - ${this.selectedDirectPay.max_price}`;
      }
      return '请先选择收款方式';
    },
  },
  created() {
    this.getPayWay();
    this.getBanklist();
    this.getcard();
  },
  methods: {
    onPayWayChange(value) {
      this.pay_way_name = value.text;
      this.pay_way_code = value.value;
      this.changPayway(value.value);
      this.popup = false;
    },
    getPayRange() {
      let type = '';
      if (this.pay_way == 'bank') type = 'bank';
      if (this.pay_way == 'wechat') type = 'wechat';
      if (this.pay_way == 'alipay') type = 'alipay';
      if (this.pay_way == 'usdt') {
        type = this.meyXi == 'ERC20' ? 'usdt-erc20' : 'usdt-trc20';
      }
      if (this.pay_way == 'direct_wechat' || this.pay_way == 'direct_alipay') {
        return;
      }
      this.showLoading();
      this.$apiFun.post('/api/getPayRange', { type }).then(res => {
        if (res.code == 200) {
          this.min_price = res.data.min_price;
          this.max_price = res.data.max_price;
        }
        this.hideLoading();
      }).catch(() => this.hideLoading());
    },
    changShow() { this.show = !this.show; },
    onConfirm(value) {
      this.bankBox.bank = value.bank_name;
      this.show = false;
    },
    onCancel() { this.show = false; },
    changXiyi(val) {
      if (this.meyXi === val) return;
      this.meyXi = val;
      this.getPayRange();
    },
    getPayWay() {
      this.showLoading();
      this.$apiFun.get('/api/get_pay_way').then(res => {
        if (res.code === 200) {
          this.payWayList = res.data;
          this.payWayList.rengong = 1;
          if (this.payWayList.wechat === 1) {
            this.pay_way = 'wechat';
          } else {
            for (let i in this.payWayList) {
              if (this.payWayList[i] == 1) {
                this.pay_way = i == 'card' ? 'bank' : i;
                break;
              }
            }
          }
          this.getPayRange();
        }
        this.hideLoading();
      }).catch(() => this.hideLoading());
    },
    loadDirectPayList(category) {
      this.showLoading();
      this.$apiFun.get('/api/get_direct_pay_list', { category }).then(res => {
        if (res.code === 200 && res.data.length) {
          this.directPayList = res.data;
          this.selectDirectPay(res.data[0]);
        } else {
          this.directPayList = [];
          this.selectedDirectPay = null;
          this.showTost(0, '暂无可用收款方式');
        }
        this.hideLoading();
      }).catch(() => this.hideLoading());
    },
    selectDirectPay(item) {
      this.selectedDirectPay = item;
      this.min_price = Number(item.min_price);
      this.max_price = Number(item.max_price);
    },
    payTest() {
      if (!this.amount || isNaN(this.amount)) {
        this.showTost(0, '请输入正确金额');
        return;
      }
      const amountNum = Number(this.amount);
      if (amountNum < this.min_price || amountNum > this.max_price) {
        this.showTost(0, `金额必须在 ${this.min_price} ~ ${this.max_price} 之间`);
        return;
      }

      if (this.pay_way === 'bank') {
        const { bank_owner, bank, bank_no, bank_address } = this.bankBox;
        if (!bank_owner) return this.showTost(0, '请输入存款人姓名');
        if (!bank) return this.showTost(0, '请选择开户银行');
        if (!bank_no) return this.showTost(0, '请输入银行卡号');
        if (!bank_address) return this.showTost(0, '请输入开户行地址');
      }

      if (this.pay_way === 'direct_wechat' || this.pay_way === 'direct_alipay') {
        if (!this.selectedDirectPay) return this.showTost(0, '请选择收款方式');
      }

      const info = {
        amount: amountNum,
        pay_way_code: this.pay_way,
      };

      if (this.pay_way === 'usdt') {
        info.paytype = 'usdt';
        info.catepay = this.meyXi;
      } else if (this.pay_way === 'wechat') {
        info.paytype = 'hipay';
      } else if (this.pay_way === 'alipay') {
        info.paytype = 'hipay';
      } else if (this.pay_way === 'bank') {
        info.paytype = 'bank';
        Object.assign(info, this.bankBox);
      } else if (this.pay_way === 'direct_wechat' || this.pay_way === 'direct_alipay') {
        info.paytype = 'direct_pay';
        info.code_pay_id = this.selectedDirectPay.id;
      }

      this.showLoading();
      this.$apiFun.post('/api/recharge', info).then(res => {
        if (res.code !== 200) {
          this.showTost(0, res.message);
          return;
        }

        if (this.pay_way === 'usdt' || this.pay_way === 'direct_wechat' || this.pay_way === 'direct_alipay') {
          this.$router.push({ path: `/payInfo?deposit_no=${res.message}` });
        } else if (this.pay_way === 'bank') {
          this.showTost(1, '提交成功，等待审核');
          this.bankBox = {};
          this.$router.push({ path: '/transRecord' });
        } else {
          location.href = res.data.h5_url || res.data.pay_url;
        }
      }).finally(() => {
        this.hideLoading();
      });
    },
    changMey(val) { this.amount = val * 1; },
    getBanklist() {
      this.$apiFun.post('/api/banklist').then(res => {
        if (res.code == 200) this.banklist = res.data;
      }).catch(() => {});
    },
    getcard() {
      this.showLoading();
      this.$apiFun.post('/api/getpaybank').then(res => {
        if (res.code == 200) this.cardLis = res.data;
        this.hideLoading();
      }).catch(() => this.hideLoading());
    },
    changPayway(val) {
      if (val == this.pay_way) return;
      this.pay_way = val;
      this.bankBox = {};
      this.amount = null;
      this.directPayList = [];
      this.selectedDirectPay = null;
      if (val === 'direct_wechat' || val === 'direct_alipay') {
        this.loadDirectPayList(val);
      } else {
        this.getPayRange();
      }
    },
    goNav(url) { this.$parent.goNav(url); },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.showTost(1, '复制成功！');
      document.body.removeChild(cInput);
    },
    getUserInfo() { this.$parent.getUserInfo(); },
    showLoading() { this.$parent.showLoading(); },
    hideLoading() { this.$parent.hideLoading(); },
    openKefu() { this.$parent.openKefu(); },
    showTost(type, title) { this.$parent.showTost(type, title); },
    getuseCardlist() {
      this.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) this.userbank = res.data;
      });
      this.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) this.userUSD = res.data;
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => { vm.getuseCardlist(); });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/2d87bbdbffeb4734e5c7.css';

.tipsh {
  width: 95%;
  margin: 6px auto;
  border-radius: 10px;
  background: #f8f8f8;
  box-sizing: border-box;
  padding: 6px;

  .tops {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.4rem;
    font-weight: 700;
    color: #333;
    height: 1rem;

    span {
      font-size: 0.29rem;
      font-weight: 400;
    }
  }

  .tsg {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .tsgs {
      flex: 1;
      text-align: center;
      font-size: 0.2rem;
      color: #a5a9b3;
    }
  }
}

.usrse {
  background: #fff;
  box-sizing: border-box;
  padding-top: 5px;

  .hgs {
    width: calc(100% - 40px);
    margin: 0 auto;
  }

  .nams {
    font-size: 0.38rem;
    color: #000;
    margin-top: 10px;
    font-weight: 700;
  }
}

.sc {
  display: flex;
  align-items: center;
  padding-bottom: 20px;

  .ssa {
    border-radius: 5px;
    border: 1px solid #f1f1f1;
    width: 2rem;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.4rem;
    font-weight: 700;
    text-align: center;
    margin-left: 1rem;
  }

  .acti {
    color: #cf866b !important;
    border: 1px solid #cf866b !important;
  }
}

.typelis {
  width: 95%;
  max-width: 100%;
  margin: 6px auto;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 6px;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 0.15rem;
  overflow-x: hidden;

  .tyls {
    border-radius: 10px;
    border: 1px solid #eee;
    text-align: center;
    width: calc(33.33% - 0.12rem);
    padding: 0.2rem 0.05rem;
    font-size: 0.26rem;
    box-sizing: border-box;

    img {
      width: 0.7rem;
      display: block;
      margin: 0 auto 0.15rem;
    }
  }

  .tyls.atc {
    border: 1px solid #cf866b;
    color: #cf866b;
  }
}

.direct-tag-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 12px;
  gap: 10px;
}

.direct-tag {
  position: relative;
  flex: 0 0 auto;
  padding: 10px 16px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  background: #fff;
  box-sizing: border-box;
  cursor: pointer;

  .direct-tag-text {
    display: block;
    font-size: 0.32rem;
    color: #333;
    line-height: 1.4;
    word-break: break-all;
  }
}

.direct-tag.atc {
  border-color: #1989fa;
  background: #fff;

  .direct-tag-text {
    color: #1989fa;
  }
}

.direct-tag-check {
  position: absolute;
  top: 0;
  right: 0;
  width: 18px;
  height: 18px;
  border-radius: 0 5px 0 8px;
  background: #1989fa;

  &::after {
    content: '';
    position: absolute;
    top: 3px;
    left: 6px;
    width: 4px;
    height: 8px;
    border: 2px solid #fff;
    border-top: 0;
    border-left: 0;
    transform: rotate(45deg);
  }
}

.lasthg {
  font-size: 0.33rem;
  color: #a5a9b3;
  padding: 0.2rem 0;
}

.bans {
  background-image: linear-gradient(180deg, #fff, #f9fcff);
  width: 90%;
  margin: 0 auto 20px;
  padding: 20px;
  border-radius: 20px;
  box-sizing: border-box;

  p {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .frists {
      width: 60px;
    }

    .sdsw {
      flex: 1;
    }

    .copy {
      color: #069b71;
    }
  }
}

[class*='van-hairline']:after {
  border: none;
}
</style>
